import "core-js/modules/es.array.map";
import "core-js/modules/es.object.freeze";

var _Separator;

import React from 'react';
import Join from "../../../Utils/Join";
import Separator from "../../../Common/Separator";
import { useLanguage } from "../../../../i18n";
import { getServiceUrl, getIsActive } from './getLinkData';
import ServiceLink from './ServiceLink';
import styles from './Services.scss';
export var KEY = Object.freeze({
  school: 'school',
  network: 'network',
  media: 'media'
});

var Services = function Services() {
  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var keys = [KEY.school, KEY.network, KEY.media];
  return /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: styles.list
  }, /*#__PURE__*/React.createElement(Join, {
    separator: _Separator || (_Separator = /*#__PURE__*/React.createElement(Separator, {
      marginTop: 0,
      marginBottom: 0
    }))
  }, keys.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item
    }, /*#__PURE__*/React.createElement(ServiceLink, {
      item: item,
      url: getServiceUrl(item, currentLang),
      isActive: getIsActive(item)
    }));
  }))));
};

export default Services;